module.exports = __webpack_public_path__ + "static/media/theme_icon_one.53451a7e.png";